/* Etiquetas multiidoma en castellano. */
export default {
  "agencySelector.agency": "Agency",
};
